var Tipo_solicitud_def_urbComponent = /** @class */ (function () {
    function Tipo_solicitud_def_urbComponent() {
        this.rows = [];
        this.solicitud_def_urb = { "DIVISION PREDIAL CON AFECTACION A UTILIDAD PUBLICA (ART. 2.2.4. N°3 OGUC)": false, "COPROPIEDAD INMOBILIARIA CON AFECTACION A  UTILIDAD PUBLICA (ART. 2.2.4.N° 2)": false };
        if (!JSON.parse(localStorage.getItem("tipo_solicitud_def_urb"))) {
            localStorage.setItem("tipo_solicitud_def_urb", JSON.stringify(this.rows));
        }
        else {
            this.rows = JSON.parse(localStorage.getItem("tipo_solicitud_def_urb"));
            this.solicitud_def_urb = {
                "DIVISION PREDIAL CON AFECTACION A UTILIDAD PUBLICA (ART. 2.2.4. N°3 OGUC)": this.rows[0] ? this.rows[0].solicitud_def_urb["DIVISION PREDIAL CON AFECTACION A UTILIDAD PUBLICA (ART. 2.2.4. N°3 OGUC)"] : false,
                "COPROPIEDAD INMOBILIARIA CON AFECTACION A  UTILIDAD PUBLICA (ART. 2.2.4.N° 2)": this.rows[0] ? this.rows[0].solicitud_def_urb["COPROPIEDAD INMOBILIARIA CON AFECTACION A  UTILIDAD PUBLICA (ART. 2.2.4.N° 2)"] : false
            };
        }
    }
    Tipo_solicitud_def_urbComponent.prototype.add_tipo_solicitud_def_urb = function () {
        localStorage.setItem("tipo_solicitud_def_urb", JSON.stringify([]));
        this.actualRow = localStorage.getItem("tipo_solicitud_def_urb");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            solicitud_def_urb: this.solicitud_def_urb
        });
        localStorage.setItem("tipo_solicitud_def_urb", JSON.stringify(this.rows));
        console.log(JSON.parse(localStorage.getItem("tipo_solicitud_def_urb")));
    };
    Tipo_solicitud_def_urbComponent.prototype.delete_tipo_solicitud_def_urb = function (id) {
        for (var x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("tipo_solicitud_def_urb", JSON.stringify(this.rows));
            }
        }
    };
    return Tipo_solicitud_def_urbComponent;
}());
export { Tipo_solicitud_def_urbComponent };
